import React from 'react';

import './SurgeryMenu.scss';

import surgeryImgs from '../../../assets/img/llc/surgery/';

class SurgeryMenu extends React.PureComponent {
  renderMenuItems = () => {
    return this.props.langs.surgery.map((surgery) => {
      const activeClass = surgery.id === this.props.surgeryActive ? "active" : "";

      return (
        <div className={`surgeryMenu_item_wrap ${activeClass}`}
             key={surgery.id}
             id={surgery.id}
             onClick={this.props.handleSurgeryClick.bind(this)}>
          <div className="surgeryMenu_item">
            <img src={surgeryImgs[surgery.imgId]} alt={surgery.id === 2 ? "Laserová a estetická medicína" : surgery.name} className="surgeryMenu_item_bg"/>
            <div className="surgeryMenu_item_content">
              <i className={`llc-${surgery.icon}`}/>
              {surgery.id === 2 ? "Laserová a estetická medicína" : surgery.name}
            </div>
          </div>
        </div>
      )
    });
  };

  render() {

    return (
      <section className="surgeryMenu">
        <div className="surgeryMenu_inner">
          {this.renderMenuItems()}
        </div>
      </section>
    );
  }
}

export default SurgeryMenu;


// WEBPACK FOOTER //
// ./src/components/Surgery/SurgeryMenu/SurgeryMenu.js